import React, { Component, PropTypes } from 'react';
import moment from 'moment';
import { connect } from "react-redux";
import { setPartners, setSelectedStartDate, setSelectedFinalDate, setRecruiterId, setClientId, setCeco } from "../actions";
import { FORMAT_DATE, FORMAT_PAYMENT_DATE, FORMAT_START_DATE } from '../consts';
import service from '../services/paymentPartnersService';
import SelectRecruiters from './../components/SelectRecruiters.jsx';
import SelectClients from './../components/SelectClients.jsx';
import SelectCeco from './../components/SelectCeco.jsx';
import SelectRange from '../../../components/shared/SelectRangeVirtualTable.jsx';
import ButtonsGroup from './../components/ButtonsGroup.jsx';
import Partners from './../components/Partners.jsx';
import ButtonsTotals from './../components/ButtonsTotals.jsx';

class PaymentPartners extends Component {
    constructor(props) {
        super(props);
        this.state = {
            paymentDate: moment().format(FORMAT_PAYMENT_DATE),
            partners: [],
            searchRun: '',
            searchName: '',
            searchCaptador: '',
            searchApprovedStatus: '',
            searchPayrollStatus: '',
            filterPendingStatus: [{
                valor: 0,
                texto: 'No Pendientes',
                seleccionado: true,
            }, {
                valor: 1,
                texto: 'Pendientes',
                seleccionado: true,
            }],
            total: 0,
            totalPending: 0,
            totalRecruited: 0,
            countPendingApproval: 0,
            countFeeTicketsPending: 0,
            countFeeTicketsDiff: 0,
            loading: false,
            cecos: [],
            showCECO: false
        };

        this.getPartners = () => {
            return service.getPartners(this.props.selectedStartDate.format('YYYY-MM-DD'), this.props.selectedFinalDate.format('YYYY-MM-DD'), this.props.recruiterId, this.props.clientId, this.props.ceco)
                .then(res => {
                    const response = res.data;
                    this.props.setPartners(response.partners);
                    this.setState({
                        total: response.totals.total,
                        totalPending: response.totals.totalPending,
                        totalRecruited: response.totals.totalRecruited,
                        countPendingApproval: response.counts.countPendingApproval,
                        countFeeTicketsPending: response.counts.countFeeTicketsPending,
                        countFeeTicketsDiff: response.counts.countFeeTicketsDiff
                    }, () => this.filterPartners())
                })
                .catch(error => {
                    return console.log(error)
                });
        };

        this.filterPartners = () => {
            const { searchRun, searchName, searchCaptador, searchApprovedStatus, searchPayrollStatus, filterPendingStatus } = this.state;
            let filterPendig = 0
            if (filterPendingStatus[0].seleccionado == true && filterPendingStatus[1].seleccionado == true) {
                filterPendig = 0
            } else if (filterPendingStatus[0].seleccionado == false && filterPendingStatus[1].seleccionado == false) {
                filterPendig = 3
            } else if (filterPendingStatus[0].seleccionado == false) {
                filterPendig = 2
            } else {
                filterPendig = 1
            }
            this.setState({
                partners: this.props.partnersRaw
                    .filter(us => us.usuarioRUN.indexOf(searchRun) >= 0)
                    .filter(us => us.nombreCompleto.toLowerCase().indexOf(searchName) >= 0)
                    .filter(us => us.recruiterName.toLowerCase().indexOf(searchCaptador) >= 0) 
                    .filter(us => us.approvedStatus.toString().indexOf(searchApprovedStatus) >= 0)
                    .filter(us => us.payrollStatus.toString().indexOf(searchPayrollStatus) >= 0)
                    .filter(us => filterPendig == 0 ? us.pendientes >= 0 : (filterPendig == 1 ? us.pendientes === 0 : (filterPendig == 3 ? us.pendientes < 0 : us.pendientes > 0)))
            });
        };

        this.onChangeFilter = (field, originalSearch) => {
            const value = typeof originalSearch === 'number' ? originalSearch : (typeof originalSearch === "object" ? originalSearch : originalSearch.trim().toLowerCase());
            this.setState({ [field]: value }, () => this.filterPartners());
        };

        this.generatePayroll = () => {
            const { selectedStartDate, selectedFinalDate, recruiterId, clientId } = this.props;
            const inPayroll = 0;
            const isApproved = 1;
            if (selectedStartDate == '' || selectedFinalDate == '' || recruiterId == '')
                return;

            const request = service.createPayroll(recruiterId, selectedStartDate.format('YYYY-MM-DD'), selectedFinalDate.format('YYYY-MM-DD'), inPayroll, isApproved);
            request
                .then(res => {
                    console.log('nómina creada correctamente')
                })
                .catch(error => console.log(error));

            return request
        };

        this.cleanFilters = () => {
            this.setState({
                searchRun: '',
                searchName: '',
                searchCaptador: '',
                filterPendingStatus: ''
            }, () => this.filterPartners())
        };

        this.onSelectRecruiterChange = (recruiterId) => {
            this.props.setRecruiterId(recruiterId);
        };

        this.onSelectClientChange = (clientId) => {
            this.props.setClientId(clientId);
            if (clientId != 0) {
                const { selectedStartDate, selectedFinalDate } = this.props;
                const request = service.getCeco(selectedStartDate.format('YYYY-MM-DD'), selectedFinalDate.format('YYYY-MM-DD'), clientId)
                request
                    .then(res => {
                        this.setState({
                            cecos: res.data,
                            showCECO: true
                        })
                    })
                    .catch(error => console.log(error));
            } else {
                this.setState({
                    showCECO: false,
                    cecos: []
                })
            }
        };

        this.onSelectCecoChange = (ceco) => {
            this.props.setCeco(ceco);
        };

        this.updateCecos = (selectedStartDate, selectedFinalDate, clientId) => {
            const request = service.getCeco(selectedStartDate.format('YYYY-MM-DD'), selectedFinalDate.format('YYYY-MM-DD'), clientId)
            request
                .then(res => {
                    this.setState({
                        cecos: res.data,
                        showCECO: this.props.clientId != 0 ? true : false
                    })
                })
                .catch(error => console.log(error));
        }

        this.onSelectUpdateRecruiter = (idPartner, recruiterId) => {
            return service.updateRecruiterPartner(idPartner, recruiterId)
                .then(alert('captador se ha modificado correctamente'))
                .catch(error => alert('ocurrio un error al modificar el captador ' + error))
        };

        this.onSelectRangoChanged = (selectedStartDate, selectedFinalDate) => {
            this.props.setSelectedStartDate(selectedStartDate);
            this.props.setSelectedFinalDate(selectedFinalDate);
            this.updateCecos(selectedStartDate, selectedFinalDate, this.props.clientId)
        };
    };

    componentDidUpdate(prevProps) {
        if (prevProps.selectedStartDate !== this.props.selectedStartDate || prevProps.recruiterId !== this.props.recruiterId || prevProps.clientId !== this.props.clientId || prevProps.ceco !== this.props.ceco) {
            this.setState({
                loading: true
            })
            this.getPartners().then(() => {
                this.setState({
                    loading: false
                })
            });
        }
    }

    componentDidMount() {
        this.setState({
            loading: true
        })
        this.getPartners().then(() => {
            this.setState({
                loading: false
            })
        });
    };

    render() {
        const {
            partners,
            searchRun,
            searchName,
            searchCaptador,
            searchApprovedStatus,
            searchPayrollStatus,
            filterPendingStatus,
            total,
            totalPending,
            totalRecruited,
            countPendingApproval,
            countFeeTicketsPending,
            countFeeTicketsDiff
        } = this.state;
        let cantidad_op_pendientes = partners.filter((partner) => {
            return partner.pendientes > 0;
        })

        let isTodosPendientes = cantidad_op_pendientes.length == partners.length;
        let isTodosAprobados = cantidad_op_pendientes.length == 0;
        return (
            <div className="container-fluid">
                <div className="row">
                    <div>
                        <SelectRecruiters
                            classname="col-md-2"
                            recruiters={this.props.recruiters}
                            onSelectRecruiterChange={this.onSelectRecruiterChange}
                            recruiterId={this.props.recruiterId}
                            label="Captador"
                            disabledAll={false}
                        />
                    </div>
                    <div className="col-md-1">
                        <SelectClients
                            clients={this.props.clients}
                            onSelectClientChange={this.onSelectClientChange}
                            clientId={this.props.clientId}
                            label="Cliente"
                            disabledAll={false}
                        />
                    </div>
                    {this.state.showCECO && <div className="col-md-1">
                        <SelectCeco
                            cecos={this.state.cecos}
                            onSelectCecoChange={this.onSelectCecoChange}
                            ceco={this.props.ceco}
                            label="CECO"
                            disabledAll={false}
                        />
                    </div>}
                    <div className="col-md-4">
                        <label className="control-label" htmlFor="selectWeek">Rango de Fecha</label>
                        <SelectRange
                            startDateSelected={this.props.selectedStartDate}
                            endDateSelected={this.props.selectedFinalDate}
                            onRangeSelected={this.onSelectRangoChanged}
                        />
                    </div>
                    <div className="col-md-2">
                        <label className="control-label" htmlFor="selectWeek">Estado aprobados</label>
                        <div style={{
                            border: '1px solid black',
                            backgroundColor: isTodosPendientes ? 'red' : isTodosAprobados ? 'green' : 'orange',
                            borderRadius: '100%',
                            height: '20px',
                            width: '20px'
                        }}></div>
                    </div>
                    <div className="col-md-3 col-md-offset-1">
                        <ButtonsGroup
                            cleanFilters={this.cleanFilters}
                            pendingApproval={partners.filter((partner) => partner.approvedStatus === 3).length > 0}
                            pendingPayroll={partners.filter((partner) => partner.payrollStatus === 1).length > 0}
                            notInPayroll={partners.filter((partner) => partner.notInPayroll > 0).length > 0}
                            total={total}
                            getPartners={this.getPartners}
                            generatePayroll={this.generatePayroll}
                        />
                    </div>
                </div>
                <div className="col-md-9">
                    <Partners
                        partners={partners}
                        searchRun={searchRun}
                        searchName={searchName}
                        searchCaptador={searchCaptador}
                        filterPendingStatus={filterPendingStatus}
                        onChangeFilterRun={this.onChangeFilter.bind(this, 'searchRun')}
                        onChangeFilterName={this.onChangeFilter.bind(this, 'searchName')}
                        onChangeFilterCaptador={this.onChangeFilter.bind(this, 'searchCaptador')}
                        onChangeFilterPending={this.onChangeFilter.bind(this, 'filterPendingStatus')}
                        selectedStartDate={this.props.selectedStartDate}
                        selectedFinalDate={this.props.selectedFinalDate}
                        recruiters={this.props.recruiters}
                        onSelectUpdateRecruiter={this.onSelectUpdateRecruiter}
                        getPartners={this.getPartners}
                        loading={this.state.loading}
                        clientId={this.props.clientId}
                        ceco={this.props.ceco}
                        recruiterId={this.props.recruiterId}
                    />
                </div>
                <div className="col-md-3" style={{ paddingTop: "38px", paddingLeft: "40px" }}>
                    <ButtonsTotals
                        total={total}
                        totalPending={totalPending}
                        totalRecruited={totalRecruited}
                        countPendingApproval={countPendingApproval}
                        countFeeTicketsPending={countFeeTicketsPending}
                        countFeeTicketsDiff={countFeeTicketsDiff}
                        onChangeFilter={this.onChangeFilter}
                        searchApprovedStatus={searchApprovedStatus}
                        searchPayrollStatus={searchPayrollStatus}
                    />
                </div>
            </div>
        )
    };
}

PaymentPartners.propTypes = {
    recruiters: PropTypes.array.isRequired
};

const mapStateToProps = (state) => {
    return {
        partnersRaw: state.partnerState.partnersRaw,
        selectedStartDate: state.dateState.selectedStartDate,
        selectedFinalDate: state.dateState.selectedFinalDate,
        recruiterId: state.partnerState.recruiterId,
        clientId: state.partnerState.clientId,
        ceco: state.partnerState.ceco
    };
};

const mapDispatchToProps = {
    setPartners,
    setSelectedFinalDate,
    setSelectedStartDate,
    setRecruiterId,
    setClientId,
    setCeco
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentPartners);


// WEBPACK FOOTER //
// ./frontEnd/treasury/payment-partners/containers/PaymentPartners.jsx